import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { InterestAction, PhotoreqAction } from "../../store/actions";

import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination } from "swiper/modules";
import { SwiperNavButtons } from "./swiprnavbutton";

import DashboardCard from "../dashboardcard/dashboardcard";
import CardBottomButton from "../dashboardcard/cardbottombutton";

import useScreenSize from "../../utils/usescreensize";

import images from "../../assets";

import "swiper/css";
import "swiper/css/pagination";
import "./styles.css";

const Carousel = (props) => {
  const screensize = useScreenSize();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const collapsed = useSelector((state) => state.ui.collapsed);
  const { interestsAll } = useSelector((state) => state.interests);
  const { photoreqAll } = useSelector((state) => state.photoreq);

  const data = props.data;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const swiperRef = useRef(null);

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.activeIndex);
    setIsEnd(swiper.isEnd);

    const totalSlidesWidth = swiper.slides.reduce(
      (acc, slide) => acc + slide.offsetWidth + swiper.params.spaceBetween,
      0
    );
    const containerWidth = swiper.width;
    setIsOverflowing(totalSlidesWidth > containerWidth);
  };

  const handleSwiperInit = (swiper) => {
    swiperRef.current = swiper;

    const totalSlidesWidth = swiper.slides.reduce(
      (acc, slide) => acc + slide.offsetWidth + swiper.params.spaceBetween,
      0
    );
    const containerWidth = swiper.width;
    setIsOverflowing(totalSlidesWidth > containerWidth);
  };

  const handleSendInterest = (id) => {
    const payload = { receiverId: id };
    dispatch(
      InterestAction.sendInterest(payload, () => {
        dispatch(InterestAction.getInterestsAll());
      })
    );
  };

  const handleSendPhotoReq = (id) => {
    const payload = { receiverId: id };
    dispatch(
      PhotoreqAction.sendPhotoreq(payload, () => {
        dispatch(PhotoreqAction.getPhotoreqAll());
      })
    );
  };

  const calculateWidth = () => {
    if (screensize.width >= 1024) {
      return collapsed ? "calc(100vw - 200px)" : "calc(100vw - 400px)";
    }
    return "100%";
  };

  return (
    <Swiper
      onSwiper={handleSwiperInit}
      onSlideChange={handleSlideChange}
      modules={[Navigation, Pagination, A11y]}
      spaceBetween={16}
      slidesPerView="auto"
      style={{
        width: calculateWidth(),
        padding: "10px",
        margin: "0px",
      }}
    >
      {data?.map((item, index) => {
        if (!item?.matchOfTheDay) {
          const interestSent = interestsAll?.some(
            (profile) => profile.receiverId === item?.username
          );

          const photoreqSent = photoreqAll?.some(
            (profile) => profile.receiverId === item?.username
          );

          return (
            <SwiperSlide key={index} className="w-[346px]">
              <DashboardCard
                item={item}
                index={index}
                redirectedfrom={props?.redirectedfrom}
              >
                <CardBottomButton
                  icon={images.cardMessage}
                  onClick={() =>
                    navigate(
                      `/messages?username=${item?.username}&firstName=${item?.firstName}&lastName=${item?.lastName}&photo=${item?.profilePicture}`
                    )
                  }
                  title="Send Message"
                />
                <CardBottomButton
                  icon={images.cardPhotoReq}
                  onClick={() => handleSendPhotoReq(item?.username)}
                  title="Send Photo Request"
                  disabled={photoreqSent}
                />
                <CardBottomButton
                  icon={images.cardmatch}
                  onClick={() => handleSendInterest(item?.username)}
                  title="Send Interest"
                  disabled={interestSent}
                />
              </DashboardCard>
            </SwiperSlide>
          );
        }
        return null;
      })}
      {isOverflowing && (
        <SwiperNavButtons
          index={currentIndex}
          isEnd={isEnd}
          isOverflowing={isOverflowing}
        />
      )}
    </Swiper>
  );
};

export default Carousel;
